import React, { Component } from 'react';
import fire from '../Firebase.js';
import AddProudOf from './AddProudOf/AddProudOf';
import ShowPride from './ShowPride/ShowPride';

class MainContainer extends Component {
    
    render(){
        return <div>
            <div className="container">
            <div className="row">
            <div className="col-md-5 add-pride">
            <h1>What are you proud of?</h1>
            <AddProudOf />
            </div>
            <div className="col-md-7">
            <ShowPride />
            </div>
            </div>
            </div>
            </div>
    }
}

export default MainContainer;


// WEBPACK FOOTER //
// ./src/MainContainer/MainContainer.js